// extracted by mini-css-extract-plugin
export var banner = "Banner_banner__8yS+8";
export var container = "Banner_container__caNS8";
export var secondaryButton = "Banner_secondaryButton__y706j";
export var themeDark = "Banner_themeDark__InVLX";
export var themeDarkTransparent = "Banner_themeDarkTransparent__Ji4z6";
export var themeLight = "Banner_themeLight__6d4Ix";
export var themeLightTransparent = "Banner_themeLightTransparent__3zhVZ";